module.exports = __webpack_public_path__ + "static/img/img_intro_eiou.14dfb39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_intro_eiou.png
// module id = vrnL
// module chunks = 1